import { render } from "./EventVideos.vue?vue&type=template&id=58f738b3"
import script from "./EventVideos.vue?vue&type=script&lang=js"
export * from "./EventVideos.vue?vue&type=script&lang=js"

import "./EventVideos.vue?vue&type=style&index=0&id=58f738b3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__